import { Component, ContentChildren, HostListener } from '@angular/core';
import { FocusKeyManager } from '@angular/cdk/a11y';

import { Subject } from 'rxjs';

import { KeyCode } from '../../../domain/key-code.enum';
import { DatePickerButtonComponent } from '../date-picker-button/date-picker-button.component';
import { DualMonthDayPickerComponent } from '../dual-month-day-picker/dual-month-day-picker.component';
import { YearPickerComponent } from '../year-picker/year-picker.component';
import { MonthPickerComponent } from '../month-picker/month-picker.component';
import { DayPickerComponent } from '../day-picker/day-picker.component';
import { DatePickerInnerComponent } from '../date-picker-inner/date-picker-inner.component';
import { SideSheetSwipeDirective } from '../../../directives/side-sheet/side-sheet-swipe.directive';
import { BottomModalComponent } from '../../bottom-modal/bottom-modal.component';
import { DatePickerComponent } from './date-picker.component';

import type { ActiveDescendantKeyManager } from '@angular/cdk/a11y';
import type { AfterContentInit, OnInit, QueryList } from '@angular/core';

@Component({
  selector: 'td-wb-slide-date-picker',
  templateUrl: 'slide-date-picker.component.html',
  imports: [
    BottomModalComponent,
    SideSheetSwipeDirective,
    DatePickerInnerComponent,
    DayPickerComponent,
    MonthPickerComponent,
    YearPickerComponent,
    DualMonthDayPickerComponent
  ]
})
export class SlideDatePickerComponent extends DatePickerComponent implements OnInit, AfterContentInit {
  @ContentChildren(DatePickerButtonComponent) items: QueryList<DatePickerButtonComponent>;
  isPanelDisplayed: Subject<boolean> = new Subject<boolean>();
  isOpen: boolean = false;
  private keyManager: ActiveDescendantKeyManager<DatePickerButtonComponent> | FocusKeyManager<DatePickerButtonComponent>;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (!this.disabled && this.isOpen) {
      this.onKeyDownOpen(event);
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterContentInit(): void {
    this.initKeyManager();
  }

  toggleCalendar(): void {
    this.isOpen = !this.isOpen;
  }

  onDatePickerChange(date: Date): void {
    super.onDatePickerChange(date);
    this.toggleCalendar();
  }

  onToggle(value: boolean): void {
    this.isPanelDisplayed.next(value);
  }

  private onKeyDownOpen(event: KeyboardEvent): void {
    const keyCode = event.key;
    const isArrowKey = keyCode === KeyCode.ARROW_DOWN || keyCode === KeyCode.ARROW_UP;
    const keyManager = this.keyManager;
    let preventDefault = true;

    if (keyCode === KeyCode.HOME) {
      keyManager.setFirstItemActive();
    } else if (keyCode === KeyCode.ESC) {
      this.toggleCalendar();
    } else if (keyCode === KeyCode.END) {
      keyManager.setLastItemActive();
    } else if (isArrowKey && event.altKey) {
      this.toggleCalendar();
    } else if ((keyCode === KeyCode.ENTER || keyCode === KeyCode.SPACE) && keyManager.activeItem !== null) {
      keyManager.activeItem.focus();
    } else {
      keyManager.onKeydown(event);
      preventDefault = false;
    }
    if (preventDefault) {
      event.preventDefault();
    }
  }

  private initKeyManager(): void {
    this.keyManager = new FocusKeyManager<DatePickerButtonComponent>(this.items)
      .withTypeAhead()
      .withVerticalOrientation()
      .withHorizontalOrientation('ltr');
  }
}
